import React from "react";
import authAxios from "../../services/Token";

class SelectRelacion extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    SubModulos: [],
}
  SubmodulosSELECT(id){

    authAxios.get("master/selectrelacion/"+id)
        .then((datosRespuesta) => {
            console.log(datosRespuesta);

            this.setState({ SubModulos: datosRespuesta.data.data });

        })
  
        .catch(console.log);
  }
  componentDidMount() {
    this.SubmodulosSELECT(this.props.t); 
  }
  render()  {
    const { SubModulos} = this.state;
    return (
      <div>
        <select className={"form-control form-control-sm"} name={this.props.nombre_input} id={this.props.nombre_input}>
               <option value="">Seleccione</option>
              {
                SubModulos.map((item,i) => (
                  
                  <option value={item[this.props.v]} key={i}>{item[this.props.c]}</option>
                  
                ))
              }
      </select>
  </div>
    )
  }
}

export default SelectRelacion;
